<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Date',
    },
    date: {
      type: String,
      default: null,
    },
    safeHaven: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newdate: this.date,
      activePicker: null,
      menu: false,
      isSafeHaven: this.safeHaven,
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    date(to, from) {
      this.newdate = to
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date)
      this.$emit('update:date', this.newdate)
      this.$emit('date-updated', this.newdate)
    },
  },
}
</script>

<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="newdate"
          :class="isSafeHaven ? $style.shTextField : $style.textField"
          :placeholder="label"
          readonly
          v-bind="[$attrs, attrs]"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="newdate"
        :active-picker.sync="activePicker"
        min="1910-01-01"
        @change="save"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.textField {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.75px;
  border-radius: 16px !important;
}

.shTextField {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.75px;
}
</style>
